import CautionIcon from "Assets/Img/CautionIcon";
import Button from "../../../../Components/Common/Button/Button";

interface AlertBannerProps {
  unassignedCount: number;
  onShowUnassigned: () => void;
}

const AlertBanner = ({
  unassignedCount,
  onShowUnassigned,
}: AlertBannerProps) => {
  if (!unassignedCount) {
    return null;
  }

  return (
    <div className="alertBanner">
      <p>
        <CautionIcon />
        <strong>
          {unassignedCount} projects have no inspector assigned.
        </strong>{" "}
        Draws cannot be processed until an inspector is assigned and a field
        inspection is completed.
      </p>
      <Button className="btn btnDangerLight btnSm" onClick={onShowUnassigned}>
        Show Unassigned
      </Button>
    </div>
  );
};

export default AlertBanner;
